import React, { Component } from 'react'
import NumberFormat from 'react-number-format'

// CKeditor
import CKEditor from 'react-ckeditor-component'
import { editorReady } from '../../../../utils/editor'
import CKEditorInput from '../../../../utils/forms/CKEditorInput'

// Components
import GeneralLoader from '../../../GeneralLoader'
import ErrorWrap from '../../../utils/error-success/ErrorWrap'

class ProfileTableBio extends Component {
	constructor(props) {
		super(props)
		this.CKEditorInput = new CKEditorInput()
	}

	render() {
		const {
			user,
			inProgress,
			personalFieldsErrors,
			reviewerOptionsLoading,
			reviewerOptionsError,
			reviewerOptions,
			translations,
		} = this.props

		return (
			<React.Fragment>
				<tr className={!!personalFieldsErrors && personalFieldsErrors.sectors ? `error` : null}>
					<th>{translations.sections.reviewer_form.work_volunteer_experience}:</th>
					<td>
						{reviewerOptionsError ? (
							<ErrorWrap>{reviewerOptionsError}</ErrorWrap>
						) : reviewerOptionsLoading ? (
							<GeneralLoader />
						) : (
							<React.Fragment>
								{!reviewerOptions || !reviewerOptions.sectors.length ? (
									<ErrorWrap>There are no experience options available at the moment.</ErrorWrap>
								) : (
									<React.Fragment>
										{Object.keys(reviewerOptions.sectors).map(key => {
											const { id } = reviewerOptions.sectors[key]

											// See if this sector is checked off
											const selectedObject = user.sectors.find(sector => {
												return sector.id === id
											})

											return (
												<div key={key} className='form-field-noclear flex-experience-field-profile'>
													<div
														className={`custom-label checkbox-label${
															inProgress ? ' disabled-label' : ''
														}`}
													>
														<input
															type='checkbox'
															id={`experience_${key}`}
															value={id}
															checked={!!selectedObject}
															disabled={inProgress}
															onChange={e => this.props.handleCheckboxClickSector(e, 'sectors')}
														/>
														<label htmlFor={`experience_${key}`}>
															{reviewerOptions.sectors[key].description}
														</label>
													</div>
													<div className='years-wrap'>
														<NumberFormat
															placeholder='0'
															decimalScale={0}
															allowNegative={false}
															value={!!selectedObject ? selectedObject.years : null}
															type='text'
															onKeyPress={e => this.props.handleKeyPress(e)}
															onChange={e => this.props.handleInputChangeSector(e, id)}
															disabled={!selectedObject || inProgress}
														/>
														<label>{translations.sections.reviewer_form.years}</label>
													</div>
												</div>
											)
										})}
									</React.Fragment>
								)}
							</React.Fragment>
						)}
					</td>
				</tr>
				<tr
					className={
						!!personalFieldsErrors && personalFieldsErrors.dietary_allergies ? `error` : null
					}
				>
					<th>{translations.sections.reviewer_form.dietary_restrictions}:</th>
					<td>
						<input
							type='text'
							id='dietary_allergies'
							placeholder={translations.sections.reviewer_form.dietary_placeholder}
							value={user.dietary_allergies}
							maxLength='255'
							disabled={inProgress}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
						/>
					</td>
				</tr>

				<tr
					className={
						!!personalFieldsErrors && personalFieldsErrors.accessibility_requirements
							? `error`
							: null
					}
				>
					<th>{translations.sections.reviewer_form.accessibility_requirements}:</th>
					<td>
						<input
							type='text'
							id='accessibility_requirements'
							placeholder={translations.sections.reviewer_form.accessibility_placeholder}
							value={user.accessibility_requirements}
							maxLength='255'
							disabled={inProgress}
							onKeyPress={e => this.props.handleKeyPress(e)}
							onChange={e => this.props.handleInputChange(e)}
						/>
					</td>
				</tr>

				<tr className={!!personalFieldsErrors && personalFieldsErrors.bio ? `error` : null}>
					<th>{translations.sections.reviewer_form.bio}:</th>
					<td>
						<CKEditor
							scriptUrl='/ckeditor/ckeditor.js'
							content={user.bio}
							config={{
								toolbar: 'None',
								filebrowserBrowseUrl: '/file-browser',
								uploadUrl: process.env.REACT_APP_API_URL + `files`,
								bodyClass: 'cke-noborder',
								extraPlugins: 'autogrow',
								removePlugins: 'magicline',
								height: 50,
								margin: 0,
								autoGrow_minHeight: 50,
							}}
							events={{
								instanceReady: editorReady.bind(this),
								change: this.props.editorChange.bind(this, 'bio'),
							}}
							ref={instance => {
								this.CKEditorInput.addEditor('bio', instance)
							}}
						/>
					</td>
				</tr>
				<tr className={!!personalFieldsErrors && personalFieldsErrors.experience ? `error` : null}>
					<th>{translations.sections.reviewer_form.other_relevant_training}:</th>
					<td>
						<CKEditor
							scriptUrl='/ckeditor/ckeditor.js'
							content={user.experience}
							config={{
								toolbar: 'None',
								filebrowserBrowseUrl: '/file-browser',
								uploadUrl: process.env.REACT_APP_API_URL + `files`,
								bodyClass: 'cke-noborder',
								extraPlugins: 'autogrow',
								removePlugins: 'magicline',
								height: 50,
								margin: 0,
								autoGrow_minHeight: 50,
							}}
							events={{
								instanceReady: editorReady.bind(this),
								change: this.props.editorChange.bind(this, 'experience'),
							}}
							ref={instance => {
								this.CKEditorInput.addEditor('experience', instance)
							}}
						/>
					</td>
				</tr>
				<tr className={!!personalFieldsErrors && personalFieldsErrors.comments ? `error` : null}>
					<th>{translations.sections.reviewer_form.comments}:</th>
					<td>
						<CKEditor
							scriptUrl='/ckeditor/ckeditor.js'
							content={user.comments}
							config={{
								toolbar: 'None',
								filebrowserBrowseUrl: '/file-browser',
								uploadUrl: process.env.REACT_APP_API_URL + `files`,
								bodyClass: 'cke-noborder',
								extraPlugins: 'autogrow',
								removePlugins: 'magicline',
								height: 50,
								margin: 0,
								autoGrow_minHeight: 50,
							}}
							events={{
								instanceReady: editorReady.bind(this),
								change: this.props.editorChange.bind(this, 'comments'),
							}}
							ref={instance => {
								this.CKEditorInput.addEditor('comments', instance)
							}}
						/>
					</td>
				</tr>
			</React.Fragment>
		)
	}
}

export default ProfileTableBio



// WEBPACK FOOTER //
// ./src/components/reviewer/profile/profile-table/ProfileTableBio.js